import React from "react";
import useStyles from "../../partner/style";
import { TextField } from "@material-ui/core";

const InputNumber = ({ text, setValue, label, name, placeholder, isEnable, isRequired, key }) => {
    const classes = useStyles();
    const onChange = (e) => {
        setValue(e.target.value);
    }

    return (
        <div>
            <div className={classes.divLabel}>
                <p className={classes.label} >{label}</p>
                {isRequired ? (
                    <p style={{ fontSize: 26, color: "#FF0000" }}>*</p>
                ) : (
                    <></>
                )}
            </div>

            <TextField
                key={key}
                InputProps={{
                    classes: {
                        focused: classes.textBorderEntry,
                        input: classes.inputEntry,
                    },
                }}
                disabled={isEnable ?? false}
                value={text}
                onChange={onChange}
                placeholder={placeholder}
                type={"number"}
                onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                name={name}
                //onKeyUp={validateField}
                //onBlur={validateField}
                style={{ width: '90%' }}
                inputStyle={{ width: '90%' }}
            />
        </div>
    );
}

export default InputNumber;